import React from 'react';
import axios from 'axios';
import { INFLUENCERS_ENDPOINTS } from '../../../config/api';
import { useTranslation } from 'react-i18next';
import ResponsiveHeader from '../../../shared/components/ResponsiveHeader';
import ActiveOffers from "./ActiveOffers";
import AvailableOffers from "./AvailableOffers";
import WelcomeMsg from "./WelcomeMsg";
import { useState, useCallback } from 'react';
import { useEffect } from 'react';
import TOSAcceptance from "../../../shared/components/TOSAcceptance";
import { signOut } from '../../../actions/auth.actions';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";


const Home = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();


  const [state, setState] = useState({
    simulatedUserId: localStorage.getItem('simulatedUser')
  });

  useEffect(() => {
    if (state.simulatedUserId !== localStorage.getItem('simulatedUser')) {
      setState({ simulatedUserId: localStorage.getItem('simulatedUser') });
    }
  }, state.simulatedUserId);

  useEffect(() => {
    checkForceReloadStatus();
  }, []);

  const checkForceReloadStatus = () => {
    axios.get(INFLUENCERS_ENDPOINTS.FORCE_RELOAD_STATUS)
      .then((response) => {
        if (response.data.reload_page) {
          const influencerForceFrontendReload = response.data.influencer_force_frontend_reload;
          console.log(`previous reloading time: ${localStorage.getItem('influencerForceFrontendReload')}`);
          console.log(`new reloading time: ${influencerForceFrontendReload}`);
          if(localStorage.getItem('influencerForceFrontendReload') != influencerForceFrontendReload) {
            console.log('reloading...');
            localStorage.setItem('influencerForceFrontendReload', response.data.influencer_force_frontend_reload);
            setInterval(window.location.reload(true), 1000);
          }
        }
        else
          console.log('no reload time set');
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleLogout = useCallback(() => {
    axios.delete('/api/v1/influencers/users/sign_out')
      .then(({ data }) => {
        signOut(dispatch);
        history.push('/signin');
        window.location.reload(true);
      }).catch(() => {
        dispatch(addFlashMessage({
          text: t('influencers.common.message_error'),
          type: 'error'
        }));
      });
  }, [history, signOut]);

  return (
    <div>
      <WelcomeMsg handleLogout={handleLogout} />
      <TOSAcceptance />
      <div className="container">
        <div className="home-page page row">
          <div className='main-page-title col-sm-12 col-lg-4'>
            <ResponsiveHeader className="mb-4" xs="h4" sm="h3">
              {t('influencers.pages.home.title')}
            </ResponsiveHeader>
          </div>
          <div className='home-page-content col-sm-12 col-lg-8'>
            <ActiveOffers simulatedUserId={state.simulatedUserId} />
            <AvailableOffers simulatedUserId={state.simulatedUserId} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
